/**
 * quantitySchedule Normalizr Schema
 */
import { schema } from 'normalizr';

const quantitySchedule = new schema.Entity('quantitySchedules');

export default quantitySchedule;
